/**
 * ErrorBoundary Component
 * Catches errors in child components and displays fallback UI
 */
import { h, Component } from 'preact';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Caught error:', error);
    console.error('[ErrorBoundary] Error info:', errorInfo);
    console.error('[ErrorBoundary] Stack:', error?.stack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div style="padding: 40px; text-align: center; color: #999;">
          <h2>Something went wrong</h2>
          <p>{this.state.error?.message || 'Unknown error'}</p>
          <pre style="text-align: left; background: #1a1a1a; padding: 20px; margin: 20px auto; max-width: 600px; overflow: auto;">
            {this.state.error?.stack}
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}
